import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { SettingsService } from '../service/settings.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommentsService } from '../service/comments.service';
import { TranslateService } from '@ngx-translate/core';
import { contextLicenseFreeAccess } from 'na-lib';

@Component({
    selector: 'app-settings-dialog',
    templateUrl: './settings-dialog.component.html',
    styleUrls: ['./settings-dialog.component.css'],
    standalone: false
})
export class SettingsDialogComponent implements OnInit {
  @Input('app-settings-dialog') data:any
  settingsData={
    contextIds:[],
    contextIdsNames:[],
    account:"",
    user:""
  }
  settingsForm!:FormGroup
  selected:any
  newIdUser:string
  oldAccount:any
  actualRoute:string
  title:string
  contextLicenseFree = false
  contextLicenseFreeAccess = contextLicenseFreeAccess
  selectedName:string

  constructor(
    public dialogRef: MatDialogRef<SettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any[],
    private authService: AuthService,
    private router: Router,
    private commentService: CommentsService,
    private settingsService: SettingsService,
    private fb: FormBuilder,
    private translate:TranslateService
    ){

      dialogRef.disableClose = true;
    }
  async ngOnInit(): Promise<void> {

    this.settingsService.contextLicenseFreePublisher$.subscribe( value => {
      this.contextLicenseFree = value
    })

    this.commentService.progressSpin.emit(true)
    if(this.dialogData['title'])
      this.title = this.dialogData['title']
    else
      this.title = this.translate.instant('settings')
    
    this.actualRoute = this.router.url

    if(this.settingsService.userNameChange$.getValue()){
      this.settingsData.user = this.settingsService.userNameChange$.value
    }

  if(this.settingsService.contextId$)
    this.selected = this.settingsService.contextId$

  this.settingsService.contextIdChange$.subscribe( value => {
    this.selected = value
  })

   this.settingsService.selectedContextDataChange$.subscribe( value => {
    if(value.displayName){
      this.selected = value.id
      this.settingsForm.patchValue({id:this.selected})
    }
  })

    this.settingsService.userNameChange$.subscribe(value=>{
      this.commentService.progressSpin.emit(false)
      this.settingsData.user = value
    })

    this.settingsForm = this.fb.group({
      id:[this.selected]
    })

    if(this.settingsService.userAccount$){
      const contextIds = this.settingsService.userAccount$.contextIds
      if(contextIds){
        this.settingsData.contextIds = contextIds
        this.getNamesOfContextIds(contextIds)
      }
    }

    this.settingsService.userDataChange$.subscribe( value => {
      if(value.contextIds){
        this.settingsData.contextIds = value.contextIds
        this.getNamesOfContextIds(value.contextIds)
      }
    })

    this.settingsService.allcontextIdsChange$.subscribe( contextIds => {
      this.commentService.progressSpin.emit(true)
    })

    if(this.settingsData.contextIdsNames){
      if(this.settingsData.contextIds.length >= this.settingsData.contextIdsNames.length && this.settingsData.contextIdsNames.length>0){
        this.commentService.progressSpin.emit(false)
        this.showSelectedContext()
      }
    }
  }

  showSelectedContext(){
    if(this.settingsData.contextIdsNames.length>0){
      this.selectedName = this.settingsData.contextIdsNames.find( context => context.id === this.selected)?.displayName
    }
  }

  async getNamesOfContextIds(contextIds){
    this.commentService.progressSpin.emit(true)

    try{
      if(this.settingsService.userContextIdsData$.value?.length==0){
        this.settingsService.observeUserContextIdsData(contextIds)
      
        this.settingsService.userContextIdsData$.subscribe( value => {
          this.settingsData.contextIdsNames= value.sort(function (a, b) {
            return a?.displayName.toLowerCase().localeCompare(b?.displayName.toLowerCase());
          })
          this.commentService.progressSpin.emit(false)
          this.showSelectedContext()
  
        })
      }else{
        this.settingsData.contextIdsNames= this.settingsService.userContextIdsData$.value?.sort(function (a, b) {
          return a?.displayName.toLowerCase().localeCompare(b?.displayName.toLowerCase());
        })
        this.showSelectedContext()
        this.commentService.progressSpin.emit(false)
      }

    }catch(error){}
  }

  onSaveSettings(){
    this.commentService.progressSpin.emit(true)
    const newSelContext = this.settingsForm.value.id
    const contextName = this.settingsData.contextIdsNames.find( context => context.id === newSelContext)?.displayName
    this.dialogRef.close([{id:newSelContext, displayName: contextName},true])
    if(this.dialogData['title'] == 'Select Account'){
      const route = 'home/' + newSelContext
      this.router.navigate([route])
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.CONTEXT_CHANGE")
      this.commentService.addSnackBar.emit(message)

    }else{
      setTimeout(() => {
      const newRoute = '/home/' + newSelContext

      this.router.navigate([newRoute])
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.CONTEXT_CHANGE")
      this.commentService.addSnackBar.emit(message)
      }, 500);
    }
  }

  onCancelSettings(){
    const newSelContext = this.settingsForm.value.id
    const contextName = this.settingsData.contextIdsNames.find( context => context.id === newSelContext)?.displayName
    this.dialogRef.close([{id:newSelContext, displayName: contextName}, false])
  }
}
